import React from "react"
import { Map, Placemark, YMaps } from "react-yandex-maps"
import Marker from "../../assets/icons/marker-red.png"

export default () => {
  return (
    <YMaps>
      <Map
        defaultState={{
          center: [40.379922, 71.790068],
          zoom: 9,
          type: "yandex#map",
          controls: ["zoomControl", "fullscreenControl"],
        }}
        modules={["control.ZoomControl", "control.FullscreenControl"]}
        style={{ width: "100%", height: "100%" }}
      >
        <Placemark
          defaultGeometry={[40.379922, 71.790068]}
          options={{
            iconLayout: "default#image",
            iconImageHref: Marker,
            iconImageSize: [43, 45],
            iconImageOffset: [-3, -42],
          }}
        />
      </Map>
    </YMaps>
  )
}
